
export default [
    {
        "id": 1,
        "name": "商品売買の処理方法",
        "sort": 1
    },
    {
        "id": 2,
        "name": "割戻し",
        "sort": 2
    },
    {
        "id": 3,
        "name": "サービス業の処理",
        "sort": 3
    },
    {
        "id": 4,
        "name": "簿記上の現金",
        "sort": 4
    },
    {
        "id": 5,
        "name": "銀行勘定調整表の作成",
        "sort": 5
    },
    {
        "id": 6,
        "name": "手形の裏書き",
        "sort": 6
    },
    {
        "id": 7,
        "name": "手形の割引き",
        "sort": 7
    },
    {
        "id": 8,
        "name": "手形の不渡り",
        "sort": 8
    },
    {
        "id": 9,
        "name": "手形の更改",
        "sort": 9
    },
    {
        "id": 10,
        "name": "営業外受取手形と営業外支払手形",
        "sort": 10
    },
    {
        "id": 11,
        "name": "電子記録債権（債務）",
        "sort": 11
    },
    {
        "id": 12,
        "name": "売掛金の譲渡",
        "sort": 12
    },
    {
        "id": 13,
        "name": "債務の保証",
        "sort": 13
    },
    {
        "id": 14,
        "name": "有形固定資産の割賦購入",
        "sort": 14
    },
    {
        "id": 15,
        "name": "減価償却",
        "sort": 15
    },
    {
        "id": 16,
        "name": "有形固定資産の売却",
        "sort": 16
    },
    {
        "id": 17,
        "name": "有形固定資産の買換え",
        "sort": 17
    },
    {
        "id": 18,
        "name": "有形固定資産の除却と廃棄",
        "sort": 18
    },
    {
        "id": 19,
        "name": "建設仮勘定",
        "sort": 19
    },
    {
        "id": 20,
        "name": "有形固定資産の改良と修繕",
        "sort": 20
    },
    {
        "id": 21,
        "name": "有形固定資産の滅失",
        "sort": 21
    },
    {
        "id": 22,
        "name": "圧縮記帳",
        "sort": 22
    },
    {
        "id": 23,
        "name": "ファイナンス・リース取引の処理",
        "sort": 23
    },
    {
        "id": 24,
        "name": "オペレーティング・リース取引の処理",
        "sort": 24
    },
    {
        "id": 25,
        "name": "無形固定資産",
        "sort": 25
    },
    {
        "id": 26,
        "name": "ソフトウェア",
        "sort": 26
    },
    {
        "id": 27,
        "name": "研究開発費",
        "sort": 27
    },
    {
        "id": 28,
        "name": "株式の処理",
        "sort": 28
    },
    {
        "id": 29,
        "name": "公社債の処理",
        "sort": 29
    },
    {
        "id": 30,
        "name": "有価証券の期末評価",
        "sort": 30
    },
    {
        "id": 31,
        "name": "貸倒引当金",
        "sort": 31
    },
    {
        "id": 32,
        "name": "修繕引当金",
        "sort": 32
    },
    {
        "id": 33,
        "name": "賞与引当金",
        "sort": 33
    },
    {
        "id": 34,
        "name": "退職給付引当金",
        "sort": 34
    },
    {
        "id": 35,
        "name": "商品保証引当金",
        "sort": 35
    },
    {
        "id": 36,
        "name": "外貨建取引の処理",
        "sort": 36
    },
    {
        "id": 37,
        "name": "決済時の処理",
        "sort": 37
    },
    {
        "id": 38,
        "name": "決算時の処理",
        "sort": 38
    },
    {
        "id": 39,
        "name": "為替予約",
        "sort": 39
    },
    {
        "id": 40,
        "name": "株式の発行",
        "sort": 40
    },
    {
        "id": 41,
        "name": "合併",
        "sort": 41
    },
    {
        "id": 42,
        "name": "損益勘定からの振り替え",
        "sort": 42
    },
    {
        "id": 43,
        "name": "剰余金の配当と処分",
        "sort": 43
    },
    {
        "id": 44,
        "name": "準備金積立額の計算",
        "sort": 44
    },
    {
        "id": 45,
        "name": "株主資本等変動計算書",
        "sort": 45
    },
    {
        "id": 46,
        "name": "消費税",
        "sort": 46
    },
    {
        "id": 47,
        "name": "法人税等",
        "sort": 47
    },
    {
        "id": 48,
        "name": "課税所得の計算",
        "sort": 48
    },
    {
        "id": 49,
        "name": "税効果会計",
        "sort": 49
    },
    {
        "id": 50,
        "name": "収益認識の基本",
        "sort": 50
    },
    {
        "id": 51,
        "name": "契約資産",
        "sort": 51
    },
    {
        "id": 52,
        "name": "売上割戻し",
        "sort": 52
    },
    {
        "id": 53,
        "name": "本支店間の取引",
        "sort": 53
    },
    {
        "id": 54,
        "name": "支配獲得日の連結",
        "sort": 54
    },
    {
        "id": 55,
        "name": "支配獲得後１年目の連結",
        "sort": 55
    },
    {
        "id": 56,
        "name": "内部取引高、債権債務の相殺消去",
        "sort": 56
    },
    {
        "id": 57,
        "name": "手形取引の修正",
        "sort": 57
    },
    {
        "id": 58,
        "name": "貸倒引当金の修正",
        "sort": 58
    },
    {
        "id": 59,
        "name": "未実現利益の消去（商品）",
        "sort": 59
    },
    {
        "id": 60,
        "name": "未実現利益の消去（土地）",
        "sort": 60
    },
    {
        "id": 61,
        "name": "材料費の処理",
        "sort": 61
    },
    {
        "id": 62,
        "name": "材料の棚卸減耗",
        "sort": 62
    },
    {
        "id": 63,
        "name": "予定消費単価を用いた場合",
        "sort": 63
    },
    {
        "id": 64,
        "name": "材料副費の予定配賦",
        "sort": 64
    },
    {
        "id": 65,
        "name": "労務費の処理",
        "sort": 65
    },
    {
        "id": 66,
        "name": "予定賃率を用いた場合",
        "sort": 66
    },
    {
        "id": 67,
        "name": "経費の処理",
        "sort": 67
    },
    {
        "id": 68,
        "name": "製造間接費の予定配賦",
        "sort": 68
    },
    {
        "id": 69,
        "name": "本社工場会計の仕訳",
        "sort": 69
    },
    {
        "id": 70,
        "name": "標準原価計算の勘定記入",
        "sort": 70
    }
]